"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncounterDiagnosis = void 0;
/**
 * An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.
 */
var EncounterDiagnosis = /** @class */ (function () {
    function EncounterDiagnosis() {
    }
    return EncounterDiagnosis;
}());
exports.EncounterDiagnosis = EncounterDiagnosis;
